import {injectable} from 'inversify';
import {ICardSourceAdapter} from "@intelingu/core/stores/adapters/ICardSourceAdapter";
import {
    CardModel,
    CardType,
    EvaluationMark,
    PreloadBufferItem,
    TopicCardModel, TopicModel
} from "@intelingu/core/interfaces/models/CardModel";
import {CardApi} from "@intelingu/core/api/CardApi";

@injectable()
export class BackendCardSourceAdapter implements ICardSourceAdapter {

    constructor(
        private cardApi: CardApi
    ) {}

    async evaluate(id: number, courseId: number, nextId: number, mark: EvaluationMark, update: boolean, log: string): Promise<any> {
        return this.cardApi.evaluate(id, nextId, mark, update, log);
    }

    async getCard(courseId: number): Promise<CardModel> {
        return (await this.cardApi.getCard(courseId)).data;
    }

    async getTopic(courseId: number, topicId: number): Promise<TopicModel> {
        const response = await this.cardApi.getTopic(topicId);
        return response.data;
    }

    async preload(courseId: number): Promise<PreloadBufferItem> {
        const data = await this.cardApi.getPreload(courseId);

        return data.data;
    }

    skip(courseId: number, id: number, nextId: number): Promise<any> {
        return this.cardApi.skip(id, nextId);
    }

    async getCardById(cardId: number): Promise<CardModel> {
        return (await this.cardApi.getCardById(cardId)).data;
    }

}
